'use client';

import { useEffect } from 'react';
import useLocalStorage from '@/hooks/useLocalStorage';

export const SOUNDS_ENABLED_KEY = 'sounds_enabled';
export const SOUNDS_ENABLED_EVENT = 'sounds_enabled_changed';

function useGeneralSounds() {
  const [soundsEnabled, setSoundsEnabled] = useLocalStorage(SOUNDS_ENABLED_KEY, false);

  useEffect(() => {
    const handleCustom = (event: Event) => {
      if (event instanceof CustomEvent) {
        setSoundsEnabled(Boolean(event.detail));
      }
    };

    const handleStorage = (event: StorageEvent) => {
      if (event.storageArea !== localStorage || event.key !== SOUNDS_ENABLED_KEY) {
        return;
      }
      try {
        setSoundsEnabled(event.newValue !== null && JSON.parse(event.newValue) === true);
      } catch {
        setSoundsEnabled(false);
      }
    };

    window.addEventListener(SOUNDS_ENABLED_EVENT, handleCustom);
    window.addEventListener('storage', handleStorage);
    return () => {
      window.removeEventListener(SOUNDS_ENABLED_EVENT, handleCustom);
      window.removeEventListener('storage', handleStorage);
    };
  }, [setSoundsEnabled]);
  const setSoundsEnabledWithDispatch = (value: boolean) => {
    setSoundsEnabled(value);
    window.dispatchEvent(new CustomEvent<boolean>(SOUNDS_ENABLED_EVENT, { detail: value }));
  };

  return [soundsEnabled, setSoundsEnabledWithDispatch] as const;
}

export default useGeneralSounds;
